import { ReactNode } from 'react'

const SpotlightContainer = ({ children }: { children: ReactNode }) => {
    return (
        <div className="relative">
            <div className={'relative top-0 right-0 z-10 flex flex-col gap-[6px] md:absolute md:w-adCarousel md:gap-3'}>
                {children}
            </div>
        </div>
    )
}

export default SpotlightContainer
